
import { Mapper } from "../../../../base/utils/mapper";
import { HealthHabitPhysiotherapyResponseModel } from "../../../../domain/models/consult/health-habit-physiotherapy-response.model";
import { HealthHabitPhysiotherapyResponseEntity } from "../entities/health-habit-physiotherapy-response.entity";
export class HealthHabitPhysiotherapyImplementationRepositoryMapper extends Mapper<HealthHabitPhysiotherapyResponseEntity, HealthHabitPhysiotherapyResponseModel>{
        mapFrom(param:  HealthHabitPhysiotherapyResponseEntity):  HealthHabitPhysiotherapyResponseModel { 
            return {
                data:param.data,
                isSuccess:param.isSuccess,
                message:param.message,
                errors:param.errors
            }; 
        }
        mapTo(param:  HealthHabitPhysiotherapyResponseModel):  HealthHabitPhysiotherapyResponseEntity {
            return {
                data:param.data,
                isSuccess:param.isSuccess,
                message:param.message,
                errors:param.errors 
            };
        }
    }